import { createReducer, on } from '@ngrx/store';

import { ItemActions } from '@item/state';

export interface ItemState {
  itemLotNumberCheck: string;
}

export const initialState: ItemState = {
  itemLotNumberCheck: null,
};

export const reducer = createReducer<ItemState>(
  initialState,

  on(
    ItemActions.RequestlotRequiredCheckOnItemSuccess,
    (state, action): ItemState => ({
      ...state,
      itemLotNumberCheck: action.data.lotrequired,
    })
  )
);
